import { reactive } from "vue";
import { ws_instance } from "../websocket/ws-instance";
import { authState } from "./auth";
import { getCallId } from "./callState";

export const reactionsState = reactive({
  currentCount: 0,
});

interface InputReactionData {
  user_id: string;
}

interface OutputReactionData {
  call_id: string;
}

ws_instance.on("reaction", (data: InputReactionData) => {
  if (data.user_id !== authState.id) {
    reactionsState.currentCount++;
    setTimeout(() => {
      reactionsState.currentCount--;
    }, 11000);
  }
});

export function fireReaction() {
  const event: OutputReactionData = {
    call_id: getCallId(),
  };
  ws_instance.api_message("reaction", event);
  reactionsState.currentCount++;
  setTimeout(() => {
    reactionsState.currentCount--;
  }, 11000);
}
